import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';

const CSS_COLOR_PATTERN =
  /^(#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})|rgba?\([^)]+\)|hsla?\([^)]+\)|var\([^)]+\)|[a-z]+)$/i;

function isValidCssColor(value: string | undefined): value is string {
  if (!value) {
    return false;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  return CSS_COLOR_PATTERN.test(trimmed);
}

@Component({
  selector: 'eventq-alert',
  imports: [PrefixUrlPipe],
  templateUrl: './alert.html',
  styleUrl: './alert.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAlert {
  readonly heading = input.required<string>();
  readonly body = input.required<string>();
  readonly iconSrc = input.required<string>();

  readonly backgroundColor = input<string | undefined>(undefined);
  readonly borderColor = input<string | undefined>(undefined);
  readonly dateRangeStart = input<string | undefined>(undefined);
  readonly dateRangeEnd = input<string | undefined>(undefined);
  readonly dateIconSrc = input<string | undefined>(undefined);
  readonly username = input<string | undefined>(undefined);
  readonly userIconSrc = input<string | undefined>(undefined);
  readonly loading = input(false, { transform: booleanAttribute });

  readonly resolvedBackgroundColor = computed(() => {
    const value = this.backgroundColor();
    return isValidCssColor(value) ? value.trim() : undefined;
  });

  readonly resolvedBorderColor = computed(() => {
    const value = this.borderColor();
    return isValidCssColor(value) ? value.trim() : undefined;
  });

  readonly usesDefaultSurface = computed(
    () => !this.resolvedBackgroundColor() || !this.resolvedBorderColor(),
  );

  readonly showDate = computed(() => {
    const start = this.dateRangeStart()?.trim();
    const end = this.dateRangeEnd()?.trim();
    return Boolean(start || end);
  });

  readonly showUser = computed(() => Boolean(this.username()?.trim()));

  readonly showMetadata = computed(() => this.showDate() || this.showUser());
}
